<div class="model-content">
    <div class="congrts-animation">
        <lottie-player src="assets/img/treasure_hunt/team-reg-success/team-success.json" background="transparent" speed="1"  loop autoplay></lottie-player>
    </div>

    <div class="message">
        <p *ngIf="!message">{{'TREASURE_HUNT.TEAM_CREATION.YOUR_TEAM_IS_READY' | translate}}</p>
        <p *ngIf="message">{{message}}</p>
    </div>

    <div *ngIf="!message" class="fitst-block img-block">
        <div class="txt-img-block" *ngFor="let member of addedMembers.slice(0, 3)">
            <img *ngIf="member.avatar" [src]="member?.avatar?.thumbnail"/>
            <img *ngIf="!member.avatar" src="/assets/img/treasure_hunt/avatar/default_bog_user.png">
            <p class="member-name">{{member?.Fname }}</p>
        </div>
    </div>

    <div *ngIf="!message"  class="img-block" >
        <div  class="txt-img-block" *ngFor="let member of addedMembers.slice(3, 5)">
            <img *ngIf="member.avatar" [src]="member?.avatar?.thumbnail"/>
            <img *ngIf="!member.avatar" src="/assets/img/treasure_hunt/avatar/default_bog_user.png">
            <p class="member-name">{{member?.Fname}}</p>
        </div>
    </div>

    <ion-row class="submit-btns">
        <ion-col>
          <div class="btn-options">
            <ion-button  class="text-transform-none" [color]="huntColor" size="small" (click)="dismiss()" >{{'TREASURE_HUNT.OKAY' | translate}}</ion-button>
          </div>
        </ion-col>
      </ion-row>
</div>